(function () {
    const $window = $(window);

    const stickybar = {
        sections: null,
        vPort: 'screen-sm',
        isMobile: false,
        stickyElements: [],
        topPostition: 0,
        fixedElements: 0,
        toBeStickyOn: 'desktop', // desktop, mobile, all
        start: false,
        lock: false, // define lock and set default value, this lock will be used to make sure to run certain functionality and to run on every scroll event

        init: function () {
            stickybar.load.stickyElements();
            stickybar.control();
            setTimeout(stickybar.sticky.init, 0);
        },
        control: function () {
            $(document).on(stickybar.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                stickybar.isMobile = true;
                stickybar.sticky.on();
            });

            $(document).on(stickybar.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                stickybar.isMobile = false;
                stickybar.sticky.on();
            });
            stickybar.sticky.on();
        },
        load: {
            stickyElements: function () {
                $('.stickybar').each(function () {
                    stickybar.stickyElements.push({
                        el: $(this),
                        /** toBeStickyOn per element, could be:
                         * stickybar.toBeStickyOn       => default
                         * $(this).data('sticky-on')    => on element data attribute
                         * $(this).parent().closest('[data-sticky-on]').data('sticky-on') => on wrapper data attribute added from page builder
                         *                                                                  .parent() is required to override on element data attribute
                         **/
                        toBeStickyOn:
                            $(this).parent().closest('[data-sticky-on]').data('sticky-on') ||
                            $(this).data('sticky-on') ||
                            stickybar.toBeStickyOn,
                        start: false,
                        lock: false,
                        top: 0,
                    });
                });
            },
            fixedElements: function (i, el) {
                stickybar.fixedElements = 0;
                $('.fixed-element:not(.stickybar__wrapper,.stickybar)').each(function () {
                    stickybar.fixedElements += $(this).outerHeight();
                });

                let j = 0;
                while (j < i) {
                    if (stickybar.stickyElements[j].lock)
                        stickybar.fixedElements += stickybar.stickyElements[j].el
                            .find('.stickybar__wrapper')
                            .outerHeight();
                    j++;
                }

                // make sure header height is added if it does not have .fixed-element class
                stickybar.fixedElements += stickybar.sticky.get.headerHeight();

                if ($('.scrollThenFix.locked').length) {
                    stickybar.fixedElements = $('.scrollThenFix.locked').height();
                }
                if ($('.auto-hide-secondary-bar.slide-up').length) {
                    stickybar.fixedElements = $('.auto-hide-secondary-bar').height();
                }

                stickybar.stickyElements[i].top = stickybar.fixedElements;
            },
        },
        sticky: {
            init: function () {
                stickybar.load.fixedElements(0);

                stickybar.sticky.get.width(); // get stickybar width
                stickybar.sticky.check();

                $window.scroll(function () {
                    stickybar.sticky.check();
                    stickybar.sticky.get.width();
                });

                $window.on('smartResize load resize', function () {
                    stickybar.load.fixedElements(0);
                    stickybar.sticky.get.width();
                });
            },
            check: function () {
                // check if stickiness must be enabled
                for (let i = 0; i < stickybar.stickyElements.length; i++) {
                    const offsetYTop = window.pageYOffset; // screen y offset
                    const topPosition = stickybar.stickyElements[i].el.offset().top;

                    stickybar.load.fixedElements(i);
                    const stickyPoint = offsetYTop + stickybar.fixedElements; // get meeting point to enable stickiness
                    if (stickyPoint >= topPosition && stickybar.stickyElements[i].start) {
                        // check if stickiness point passed sticky-bar top position
                        if (!stickybar.lock) {
                            // prevent running this code in every scroll event
                            stickybar.sticky.fix(i);
                        }
                    } else {
                        stickybar.sticky.unfix(i);
                    }
                }
            },
            on: function () {
                for (let i = 0; i < stickybar.stickyElements.length; i++) {
                    const stickyOn = stickybar.stickyElements[i].toBeStickyOn;
                    switch (stickyOn) {
                        case 'desktop':
                            stickybar.stickyElements[i].start = !stickybar.isMobile;
                            break;
                        case 'mobile':
                            stickybar.stickyElements[i].start = stickybar.isMobile;
                            break;
                        case 'all':
                            stickybar.stickyElements[i].start = true;
                            break;
                    }
                }
            },
            fix: function (i) {
                stickybar.stickyElements[i].el.addClass('stickybar--sticky');
                stickybar.stickyElements[i].el.find('.stickybar__wrapper').addClass('fixed-element');
                stickybar.stickyElements[i].lock = true; // lock is enabled
            },
            unfix: function (i) {
                stickybar.stickyElements[i].lock = false; // lock is disabled
                stickybar.stickyElements[i].el.removeClass('stickybar--sticky');
                stickybar.stickyElements[i].el.find('.stickybar__wrapper').removeClass('fixed-element');
                $(document).trigger('eventSetContentPadding');
            },
            get: {
                width: function () {
                    for (let i = 0; i < stickybar.stickyElements.length; i++) {
                        if (stickybar.stickyElements[i].start) {
                            stickybar.stickyElements[i].el.find('.stickybar__wrapper').css({
                                width: stickybar.stickyElements[i].el.width(),
                                top: stickybar.stickyElements[i].top,
                            });
                        } else {
                            stickybar.stickyElements[i].el.find('.stickybar__wrapper').css({
                                width: 'auto',
                                top: 'auto',
                            });
                        }
                    }
                },
                headerHeight: function () {
                    const $header = $('header:not(.fixed-element)');
                    let isFixed = $header.hasClass('fixed');
                    isFixed = isFixed || ($header.hasClass('fixed--lg') && !stickybar.isMobile);
                    isFixed =
                        isFixed ||
                        (($header.hasClass('fixed--md') || $header.hasClass('fixed--sm')) && stickybar.isMobile);
                    return isFixed ? $header.outerHeight() : 0;
                },
            },
        },
    };

    /**
     * @deprecated
     */
    UX.stickybar = stickybar; // add to global namespace
})();
